// extracted by mini-css-extract-plugin
module.exports = {"PersonalityResults":"UserPersonalityResult_PersonalityResults__2rtTt","ResultTitle":"UserPersonalityResult_ResultTitle__18TiO"};